<div class="overflow-x-scroll">
  <ng-container *ngIf="dataTable.dataSource.loading$ | async">
    <mat-progress-bar mode="indeterminate" />
  </ng-container>

  <table
    mat-table
    matSort
    [dataSource]="dataTable.dataSource"
    [trackBy]="trackByRequest"
  >
    <ng-container matColumnDef="appointment-date">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Appointment Date
      </th>
      <td *matCellDef="let request" mat-cell class="truncate">
        <pr-formatted-event-field
          field="from"
          [event]="request.event"
          [format]="dateFormat"
        />
      </td>
    </ng-container>

    <ng-container matColumnDef="submitted">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Submitted
      </th>
      <td *matCellDef="let request" mat-cell class="truncate">
        {{ request.createdAt | moment | amDateFormat: dateFormat }}
      </td>
    </ng-container>

    <ng-container matColumnDef="practitioner">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Practitioner
      </th>
      <td *matCellDef="let request" mat-cell class="truncate">
        {{ request.practitioner.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="patient-name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Patient
      </th>
      <td *matCellDef="let request" mat-cell class="truncate">
        <span *ngIf="request.patient.patient; else primaryContact">
          {{ request.patient.patient.name }}
        </span>
        <ng-template #primaryContact>
          {{ request.patient.primaryContact.name }}
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="treatment">
      <th *matHeaderCellDef mat-header-cell class="truncate" mat-sort-header>
        Treatment
      </th>
      <td *matCellDef="let request" mat-cell class="truncate">
        {{ request.template.step.name }}
      </td>
    </ng-container>

    @if (depositsEnabled()) {
      <ng-container matColumnDef="deposit">
        <th *matHeaderCellDef mat-header-cell class="truncate">Deposit</th>
        <td *matCellDef="let request" mat-cell>
          @if (request.deposit?.metadata; as deposit) {
            <pr-deposit-actions
              paymentLinkAvailable
              resendAfterCancelAvailable
              [deposit]="deposit"
              [sendingChannel]="
                sendingPaymentLinkRequestId === request.ref.id
                  ? sendingPaymentLinkChannel
                  : undefined
              "
              [canOverrideDeposit]="(canOverrideDeposit$ | async) ?? false"
              (sendPaymentLink)="sendDepositPaymentLink(request, $event)"
              (waiveDeposit)="waiveDeposit(request, $event)"
            />
          } @else if (request.deposit?.unresolved) {
            <pr-deposit-status-chip
              [absence]="unresolvedAbsences[request.deposit.unresolved]"
            />
          } @else if (
            (flaggedPatientRequestIds$ | async) ?? undefined
              | pairMap: request.ref.id : hasFlaggedPatient
          ) {
            <pr-deposit-status-chip [absence]="patientRequiresAbsence" />
          } @else {
            <pr-deposit-status-chip [absence]="notRequiredAbsence" />
          }
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef mat-header-cell class="truncate"></th>
      <td *matCellDef="let request" mat-cell class="truncate">
        <div class="flex items-center justify-center gap-1">
          <button
            mat-icon-button
            color="warn"
            matTooltip="Cancel"
            (click)="cancelAppointmentRequest(request)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <div
            [matTooltip]="
              depositsEnabled() &&
              request.deposit?.metadata &&
              request.deposit.metadata.status !== DepositStatus.Authorised &&
              request.deposit.metadata.status !== DepositStatus.Paid &&
              request.deposit.metadata.status !== DepositStatus.Waived
                ? 'A deposit is required before confirming this request.'
                : ''
            "
            [matTooltipDisabled]="
              !(
                depositsEnabled() &&
                request.deposit?.metadata &&
                request.deposit.metadata.status !== DepositStatus.Authorised &&
                request.deposit.metadata.status !== DepositStatus.Paid &&
                request.deposit.metadata.status !== DepositStatus.Waived
              )
            "
          >
            <button
              class="confirm-button"
              mat-icon-button
              color="primary"
              [disabled]="
                depositsEnabled() &&
                request.deposit?.metadata &&
                request.deposit.metadata.status !== DepositStatus.Authorised &&
                request.deposit.metadata.status !== DepositStatus.Paid &&
                request.deposit.metadata.status !== DepositStatus.Waived
              "
              (click)="confirmAppointmentRequest(request)"
            >
              <mat-icon>check</mat-icon>
            </button>
          </div>
        </div>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayColumns()" mat-header-row></tr>
    <tr *matRowDef="let contact; columns: displayColumns()" mat-row></tr>
  </table>
</div>
